import { render } from "./Science.vue?vue&type=template&id=1a53f7c7&scoped=true&ts=true"
import script from "./Science.vue?vue&type=script&lang=ts"
export * from "./Science.vue?vue&type=script&lang=ts"

import "./Science.vue?vue&type=style&index=0&id=1a53f7c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a53f7c7"]])

export default __exports__